// MySubscription.js
import React, { useState, useEffect } from 'react';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/MySubscription.css';

const MySubscription = ({ userId }) => {
  const [subscriptionTitle, setSubscriptionTitle] = useState('');
  const [subscriptionDetails, setSubscriptionDetails] = useState('');

  useEffect(() => {
    fetchUserSubscription(userId);
  }, [userId]);

  const fetchUserSubscription = async (userId) => {
    try {
      const response = await fetch(`/api/subscriptions/${userId}`);
      const subscriptionData = await response.json();

      setSubscriptionTitle(subscriptionData.title);
      setSubscriptionDetails(subscriptionData.details);
    } catch (error) {
      console.error('Error fetching user subscription:', error);
    }
  };

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
          <h2>My Subscription</h2>
      </div>
      <div className="subscription-container">
        <h2 className="subscription-heading">Subscription Details</h2>
        <div className="subscription-details">
          <h3>{subscriptionTitle}</h3>
          <p>{subscriptionDetails}</p>
        </div>
      </div>
    </MainLayout>
  );
};

export default MySubscription;
